/* global ScrollMagic, gsap, $, jQuery */

import stickybits from "stickybits";
import { debounce, screenCategory } from '../library';

export default class HomeScrolling {
  constructor() {
    this.scrollingContainer = document.querySelector('.plastibond-features-container .scrolling-container');
    this.controller = null;
    this.scenes = [];
    this.prevScene = 0;
    this.currentScene = 0;

    if (!!this.scrollingContainer) {
      this.tl = new gsap.timeline();
      this.setup();
    }

    window.magic = this;  // TODO: for debug only, remove on live site
  }

  /**
   * Helpers function to interrupt current animation, in order to load next
   * scene animation Jump to the end value of timeline, then clear to start new
   * animation.
   */
  _clearTimeline() {
    // List of function to jump immidately to last value of timeline
    //  https://greensock.com/forums/topic/8915-jump-to-end-of-timelinelite/
    // tl.progress(1, false);
    // tl.seek(tl.duration(), false);
    // tl.time(tl.duration(), false);
    // tl.totalProgress(1, false);
    // tl.totalTime(tl.totalDuration(), false);
    this.tl.totalProgress(1, false);
  }

  _hideSceneText(sceneIndex, duration = 1) {
    const sceneTextSelector = "#section-" + sceneIndex;

    jQuery(sceneTextSelector).removeClass('active');
    jQuery('#section-trigger-' + sceneIndex).removeClass('active');

    this.tl.to(sceneTextSelector, {opacity: 0, duration: duration / 2})
      .set(sceneTextSelector + ' li', { opacity: 0, x: 50 })
      .set(sceneTextSelector, {visibility: 'hidden'})
  }

  _showSceneText(sceneIndex, duration = 1) {
    this._clearTimeline();  // if there is animation in the middle, then jump

    const targetX = (1 - sceneIndex) * 560;

    const sceneTextSelector = "#section-" + sceneIndex;

    jQuery(sceneTextSelector).addClass('active');
    jQuery('#section-trigger-' + sceneIndex).addClass('active');

    this.tl
      .set(sceneTextSelector, {visibility: 'visible'})
      .set("#scroll-content-container", {x: targetX})
      .fromTo(sceneTextSelector, {opacity: 0}, {opacity: 1, duration: duration / 2}, "<")
      .to(sceneTextSelector + ' li', {
        duration: duration / 2,
        x: 0,
        opacity: 1,
        stagger: 0.15,
        ease: "power1.inOut"
      }, "<-0.1");
  }

  _animateScene(from, to) {
    // console.warn('animateScene', from, to);
    this._clearTimeline();  // if there is animation in the middle, then jump
                            // into

    jQuery('#section-' + from).removeClass('active');

    if (from !== 1) {
      jQuery('#section-trigger-' + from).removeClass('active');
    }

    var secNameFrom = '#section-' + from, secNameTo = "#section-" + to;

    const targetX = (1 - to) * 560;
    const duration = 1;

    this.tl
      // hide all element
      .set(secNameFrom + ' li', { opacity: 0, x: 50 })
      .to(secNameFrom, {opacity: 0, duration: duration / 2})
      .set(secNameFrom, {visibility: 'hidden'})

      .set(secNameTo, {visibility: 'visible'})
      .set("#scroll-content-container", {x: targetX})
      .fromTo(secNameTo, {opacity: 0}, {opacity: 1, duration: duration / 2}, "<")
      .to(secNameTo + ' li', {
        duration: duration / 2,
        x: 0,
        opacity: 1,
        stagger: 0.15,
        ease: "power1.inOut"
      }, "<-0.1");

    jQuery('#section-' + to).addClass('active');
    jQuery('#section-trigger-' + to).addClass('active');

  }

  populateDefaultValue() {}

  clearStyles () {
    jQuery('.scroll-section-content').attr('style', '');
    jQuery('.scroll-section-content li').attr('style', '');
    jQuery('#scroll-content-container').attr('style', '');
  }

  disableScrollingScene() {

    console.log('disable Scrolling');

    this.clearStyles();

    this.scrollingContainer.classList.remove('started');
    // this.scenes.forEach((item) => { item.remove(); });
    // this.controller.enabled(false);

    this.scenes.forEach((item) => {
      item.destroy();
    });
    this.controller.destroy();

    this.scenes = [];
    this.controller = null;
  }

  enableScrollingScene() {
    if (this.controller) {
      console.log('scrolling scene already enabled. Skip');
    }
    else {
      this.initScrollingScene();
    }
  }

  setupResizeWindow() {
    window.addEventListener('resize', debounce(() => {
      this._clearTimeline();
      if (screenCategory() === 'desktop') {
        this.enableScrollingScene();
      }
      else {
        if (!this.controller) {
          console.log('Controller disabled already');
          return;
        }
        this.disableScrollingScene();
      }
    }), 500)
  }

  initScrollingScene() {
    this.controller = new ScrollMagic.Controller();

    this.scrollingContainer.classList.add('started');
    this.populateDefaultValue();

    // new ScrollMagic.Scene({
    //   triggerElement: "#section-trigger-1",
    //   // duration: 200,
    //   offset: -50,
    // })
    //   .on('enter', () => {
    //     // this.tl.from('#section-trigger-1 img', {x: 200,duration: 1})
    //   })
    //   .on('leave', () => {
    //
    //   })
    //   .addIndicators({name: "section 1"}) // add indicators
    //   .addTo(this.controller);

    setTimeout(() => {

      var trigger1 = jQuery("#section-trigger-1");


      new ScrollMagic.Scene({
        triggerElement: '#section-trigger-1',
        offset: -200,
        duration: trigger1.height() + 300,
      })
      // .setClassToggle("#section-trigger-1", 'active')
      .on('enter', () => {
        // jQuery('#section-1').addClass('active');
        // this.tl.to('#section-1', {opacity: 1, duration: 0.5})
        this._showSceneText(1);
      })
      .on('leave', () => {
        this._hideSceneText(1);
      })
      // .addIndicators('started section 1')
      .addTo(this.controller);

      var trigger2 = jQuery("#section-trigger-2");

      // scene 1 => 2
      var scene = new ScrollMagic.Scene({
        triggerElement: trigger2,
        duration: trigger2.height() + 200,
        offset: -100,
      })
        .on('enter', () => {
          // this._animateScene(1, 2);
          this._showSceneText(2);
        })
        .on('leave', () => {
          // this._animateScene(2, 1);
          this._hideSceneText(2);
        })
        // .addIndicators({ name: "section 2" }) // add indicators
        .addTo(this.controller);

      this.scenes.push(scene);

      var trigger3 = jQuery("#section-trigger-3");

      // scene 2 => 3
      var scene2 = new ScrollMagic.Scene({
        triggerElement: trigger3,
        // duration: trigger3.height() + 350,
        offset: -100
      })
        // .setTween(tween)
        // .setClassToggle("#section-trigger-3", 'active')
        .on('enter', () => {
          this._showSceneText(3)
          // this._animateScene(2, 3);
        })
        .on('leave', () => {
          this._hideSceneText(3)
          // this._animateScene(3, 2);
        })
        // .addIndicators({ name: "section 3" }) // add indicators
        .addTo(this.controller);

      this.scenes.push(scene2);
    }, 0)
  }

  /**
   * Create the universal animation for homepage
   *  Applied for both mobile and desktop, so we need to create new ScrollMagic.Controlelr()
   *  TODO: split it into seperate component
   */
  initHomeAnimation() {
    const homeController = new ScrollMagic.Controller();

    const tweenHomeHero = gsap
      .fromTo('.home-hero-outer-content > *', {
          y: 30, opacity: 0
        },
        {
          duration: 0.35,
          y: 0,
          opacity: 1,
          stagger: 0.2,
          // stagger: 1.5,
          ease: "power2.in",
        }, 0);

    new ScrollMagic.Scene({
      triggerElement: '.home-hero-container',
      reverse: false
    })
      .setTween(tweenHomeHero)
      // .addIndicators({ name: "home hero" }) // add indicators
      .addTo(homeController)

    const tweenEduction = gsap
      .fromTo('.education-views > .views-row', {
          y: 50, opacity: 0
        },
        {
          duration: 0.35,
          y: 0,
          opacity: 1,
          stagger: 0.15,
          ease: "power2.in",
        }, 0);

    new ScrollMagic.Scene({
      triggerElement: '.education-views',
      reverse: false,
      offset: -100,
    })
      .setTween(tweenEduction)
      // .addIndicators({ name: "home hero" }) // add indicators
      .addTo(homeController)
  }

  setup() {
    this.initHomeAnimation();

    // TODO: if the scrolling is not activated, then we use the default one
    if (screenCategory() === 'desktop') {
      this.initScrollingScene();
      stickybits('.scrolling-container.started .col > div');
    }

    this.setupResizeWindow();
  }
}
